import { useJoin } from "agora-rtc-react";

export const useAgoraJoin = (args: { appid: string; channel: string; token: string; uid?: string | number }, calling: boolean) => {
  const { appid, channel, token, uid } = args;
  return useJoin({ appid, channel, token: token || null, uid }, calling);
};
